import { render, staticRenderFns } from "./xiaoqu.vue?vue&type=template&id=e6bd52e8&scoped=true&"
import script from "./xiaoqu.vue?vue&type=script&lang=js&"
export * from "./xiaoqu.vue?vue&type=script&lang=js&"
import style0 from "./xiaoqu.vue?vue&type=style&index=0&id=e6bd52e8&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6bd52e8",
  null
  
)

export default component.exports